module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="pagewrapper">\n  <div id="wrapper">\n   <div id="mainbody">\n      <div class="logo"></div>\n        <div class="content-403">\n            <p>Sorry, you don\'t have permission to view this document.</p>\n            <p>Please contact us to discuss access.</p>\n            <p><strong>0800 980 1332</strong></p>\n            <p>or email</p>\n            <p><strong><a href="mailto:helpdesk@pendragon.co.uk?subject=perspective.info Access Denied">helpdesk@pendragon.co.uk</a></strong></p>\n        </div>\n    </div>\n  </div>\n</div>\n';
}
return __p;
};
